import http from "../common/services/httpService";
import { AxiosResponse } from "axios";
import queryString from "query-string";

import { Nomenclature } from "../common/components/mui-extended/SelectExtended";
import {
  ObligationRequestDto,
  ObligationRequestResultDto,
  ObligationResponsePreviewDto,
  ObligationResponseSearchResultDto,
} from "../interfaces/Obligation";

const apiEndpointRequest = "/obligationRequest";
const apiEndpointResponse = "/obligationResponse";

const sendRequestAsync = async (model: ObligationRequestDto): Promise<AxiosResponse<ObligationRequestResultDto>> => {
  return await http.post<ObligationRequestResultDto>(apiEndpointRequest, model);
};

const getResponsesAsync = async (query: string): Promise<AxiosResponse<Array<ObligationResponseSearchResultDto>>> => {
  return await http.get<Array<ObligationResponseSearchResultDto>>(`${apiEndpointResponse}?${query}`);
};

const getResponsesCountAsync = async (query: string): Promise<AxiosResponse<number>> => {
  return await http.get<number>(`${apiEndpointResponse}/count?${query}`);
};

const getResponseAsync = async (id: number): Promise<AxiosResponse<ObligationResponsePreviewDto>> => {
  return await http.get<ObligationResponsePreviewDto>(`${apiEndpointResponse}/${id}`);
};

const getDocumentTypes = async (
  offset: number = 0,
  limit: number = Number.MAX_SAFE_INTEGER,
  keyword: string = ""
): Promise<AxiosResponse<Array<Nomenclature>>> => {
  return await http.get<Array<Nomenclature>>(
    `${apiEndpointRequest}/nomenclature/documenttypes/search?offset=${offset}&limit=${limit}&keyword=${keyword}`
  );
};

const getDocumentTypesByIds = async (ids: Array<number>): Promise<AxiosResponse<Array<Nomenclature>>> => {
  const queryStringIds = queryString.stringify({ ids }, { arrayFormat: "index" });
  return await http.get<Array<Nomenclature>>(`${apiEndpointRequest}/nomenclature/documenttypes/init?${queryStringIds}`);
};

export default {
  getResponsesAsync,
  getResponsesCountAsync,
  getResponseAsync,
  sendRequestAsync,
  getDocumentTypes,
  getDocumentTypesByIds,
};
